import React from 'react'
import { SortDescriptor } from '@progress/kendo-data-query/dist/npm/sort-descriptor'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'

import campaignClientContestDetailsResultsColumn from './campaignClientContestDetailsResultsColumn'
import { CampaignDetailsResultsPage } from './CampaignDetailsResultsPage'

interface OuterProps {
  data: MarketingCampaignDetailDto
}

const sortQuery: SortDescriptor[] = []

export const CampaignClientContestDetailsResultsPage: React.FC<OuterProps> = ({ data }) => {
  return (
    <CampaignDetailsResultsPage
      data={data}
      columns={campaignClientContestDetailsResultsColumn}
      sortQuery={sortQuery}
    />
  )
}
